import React, { useEffect, useState } from 'react';
import '../css/Navbar.css';
import logo from '../assets/logo.png';
import { FaSearch, FaTimes, FaBars } from 'react-icons/fa';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';

function Navbar() {
    const [user, setUser] = useState(null);
    const [search, setSearch] = useState('');
    const [menuOpen, setMenuOpen] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    const clearSearch = () => {
        setSearch('');
    };

    return (
        <nav className="navbar">

            {/* LEFT: Logo */}
            <div className="navbar-left">
                <img src={logo} alt="Logo" className="logo" />
            </div>

            {/* CENTER TABS */}
            <div className={`nav-links ${menuOpen ? "active" : ""}`}>
                <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
                <Link to="/all-products" onClick={() => setMenuOpen(false)}>Categories</Link>
                <Link to="/top-selling" onClick={() => setMenuOpen(false)}>Top Selling</Link>
            </div>

            {/* RIGHT: Search + Menu */}
            <div className="navbar-right">
                <div className="search-container">
                    <input
                        type="text"
                        className="search-box"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    {search && (
                        <button className="clear-btn" onClick={() => setSearch('')}>
                            <FaTimes />
                        </button>
                    )}
                    <button
                        className="search-btn"
                        onClick={() => {
                            if (search.trim()) {
                                navigate(`/search?query=${encodeURIComponent(search.trim())}`);
                            }
                        }}
                    >
                        <FaSearch />
                    </button>
                </div>

                <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                    <FaBars />
                </div>
            </div>

        </nav>
    );
}

export default Navbar;